import { ReactNode } from 'react';
import { createRoot } from 'react-dom/client';

export interface WeaveModalElement extends HTMLElement {
	show: () => void;
	close: () => void;
}

interface ModalProps {
	hideClose?: boolean;
	width?: string;
	height?: string;
	title?: string;
	content: ReactNode;
}
export const newModal = ({
	hideClose = false,
	width = '',
	height = '',
	title = 'Title',
	content,
}: ModalProps) => {
	const existingModal = document.querySelector('weave-modal') as WeaveModalElement | null;
	if (existingModal) {
		existingModal.close();
		existingModal.remove();
	}

	const htmlParent = document.querySelector('html');
	if (htmlParent) {
		htmlParent.style.overflow = 'hidden';
	}
	const modal = document.createElement('weave-modal') as WeaveModalElement;
	// const actionSlot = document.createElement('div');
	// const closeButton = document.createElement('weave-button');
	modal.setAttribute('hideclose', `${hideClose}`);
	modal.setAttribute('width', `${width}`);
	modal.setAttribute('height', `${height}`);

	const titleSlot = document.createElement('h1');
	titleSlot.innerHTML = `${title}`;
	titleSlot.setAttribute('slot', 'title');

	const contentSlot = document.createElement('div');
	createRoot(contentSlot).render(content);
	//
	contentSlot.setAttribute('slot', 'content');

	// actionSlot.setAttribute('slot', 'actions');
	// closeButton.setAttribute('variant', 'solid');
	// closeButton.setAttribute('density', 'medium');
	// closeButton.innerHTML = 'Close';
	// closeButton.addEventListener('click', () => modal.close());
	// actionSlot.appendChild(closeButton);

	modal.appendChild(titleSlot);
	modal.appendChild(contentSlot);
	// modal.appendChild(actionSlot);
	document.body.appendChild(modal);

	modal.show();
	modal.addEventListener('close', () => {
		htmlParent!.style.overflow = 'auto';
	});
};
